module.exports = __webpack_public_path__ + "assets/tree.7481e9d2.svg";